import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Modal, Table, Tooltip } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  SettingOutlined,
  UserAddOutlined,
  SyncOutlined,
  ImportOutlined,
  ExportOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import AddEmployee from "./AddEmployee";
import EditEmployee from "./EditEmployee";
import SetAccount from "./SetAccount";
import SetPermission from "./SerPermission";
import SetSchedule from "./SetSchedule";
import UpdateEmployeeSched from "./UpdateEmployeeSched";

const EmployeeList = ({
  positionList,
  departmentList,
  // rerun,
  limit,
  employeeList,
  getEmployeeList,
  getUnemployeeList,
}) => {
  // const [employeeList, setEmployeeList] = useState({
  //   data: [],
  //   ready: false,
  // });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [updateDrawer, setUpdateDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [setAccountDrawer, setSetAccountDrawer] = useState(false);
  const [setPermissionDrawer, setSetPermissionDrawer] = useState(false);
  const [scheduleDrawer, setScheduleDrawer] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");
  const { rerunNotif } = useContext(NotificationInfo);

  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Fullname",
      render: (text, record) => (
        <p>
          {text.lastname}, {text.firstname} {text.middle}
        </p>
      ),
    },
    {
      title: "Address",
      render: (text, record) => (
        <p style={{ textTransform: "uppercase" }}>
          {text.street}, {text.barangay}, {text.city}
        </p>
      ),
    },
    {
      title: "Contact #",
      dataIndex: "contact_no",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Position",
      dataIndex: ["merchantemployeeposition", "position"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 180,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 180 }}>
          {parseInt(text.has_account) === 1 && (
            <Tooltip title="Set Permission">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setSetPermissionDrawer(true);
                }}
                icon={<SettingOutlined />}
                style={{ marginRight: 5 }}
              />
            </Tooltip>
          )}

          {parseInt(text.has_account) === 0 && (
            <Tooltip title="Set Account">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setSetAccountDrawer(true);
                }}
                icon={<UserAddOutlined />}
                style={{ marginRight: 5 }}
              />
            </Tooltip>
          )}

          {userData.data.usersmerpermission.find(
            ({ permission }) => permission === "allow-store-attendance"
          ) && (
            <Tooltip title="Schedule">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setScheduleDrawer(true);
                  // setSetAccountDrawer(true);
                }}
                icon={<UserAddOutlined />}
                style={{ marginRight: 5 }}
              />
            </Tooltip>
          )}

          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Move to 202">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setUpdateModal(true);
              }}
              icon={<SyncOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  // const getEmployeeList = useCallback(() => {
  //   var params = { user_id: userData.data.id, status: 1 };
  //   axios
  //     .get("user/merchant/employee-list", { params })
  //     .then((response) => {
  //       const data = response.data;
  //       setEmployeeList({ data, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  // useEffect(() => {
  //   getEmployeeList();
  // }, [getEmployeeList]);

  const searchable = employeeList.data.filter((data) => {
    return (
      data.lastname.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.firstname.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setUpdateModal(false);
      setConfirmLoading(false);
      handleMoveEmployeeTo202();
    }, 2000);
  };

  const handleMoveEmployeeTo202 = () => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.user_id);
    axios
      .post("user/merchant/update/employee-status", formdata)
      .then((response) => {
        const data = response.data;
        console.log("RESPONSE: ", data);
        if (data === "success") {
          rerunNotif("success", "Move to 202 successfully.");
          setTimeout(() => {
            getEmployeeList();
            getUnemployeeList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
          disabled={employeeList.data.length >= parseInt(limit)}
          style={{ marginRight: 5 }}
        >
          Add Employee
        </Button>
        <Button
          // type="primary"
          icon={<DownloadOutlined />}
          onClick={() => setUpdateDrawer(true)}
          disabled={employeeList.data.length === 0}
        >
          Update Schedule
        </Button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddEmployee
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          positionList={positionList}
          departmentList={departmentList}
          limit={limit}
        />
      )}

      {editDrawer && (
        <EditEmployee
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          selectedData={selectedData}
          positionList={positionList}
          departmentList={departmentList}
        />
      )}

      {setAccountDrawer && (
        <SetAccount
          open={setAccountDrawer}
          close={() => setSetAccountDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          selectedData={selectedData}
        />
      )}

      {setPermissionDrawer && (
        <SetPermission
          open={setPermissionDrawer}
          close={() => setSetPermissionDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          selectedData={selectedData}
        />
      )}

      {scheduleDrawer && (
        <SetSchedule
          open={scheduleDrawer}
          close={() => setScheduleDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title="Are you sure to move this employee to 202?"
        open={updateModal}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setUpdateModal(false)}
        centered
      />

      {updateDrawer && (
        <UpdateEmployeeSched
          open={updateDrawer}
          close={() => setUpdateDrawer(false)}
        />
      )}
    </>
  );
};

export default EmployeeList;
